"use client";

import { Button, Typography } from "@cappelendamm/design-system/react";
import { ArrowRight } from "iconoir-react";
import classNames from "classnames";
import { EvaluationCopyBookList } from "@/evaluation-copy/book-select-stage/EvaluationCopyBookList";
import { useCart } from "@/cart";
import { getCartNumberOfItems } from "@/cart/selectors";
import { useRouter } from "next/navigation";
import { EVALUATION_COPY_PATHS } from "@/evaluation-copy/constants";

export const EvaluationCopyBookSelectStage = () => {
  const { cart, isPending } = useCart();
  const router = useRouter();

  const canProceed = !isPending && getCartNumberOfItems(cart) > 0;
  return (
    <section className="flex flex-col gap-6">
      <Typography as="h1" variant="title-lg" className="mb-4 hidden sm:block">
        Velg bøker
      </Typography>
      <EvaluationCopyBookList />
      <div className="flex justify-end">
        <Button
          type="submit"
          onClick={() => router.push(EVALUATION_COPY_PATHS.TYPE_SELECTION)}
          disabled={!canProceed}
          className={classNames("w-fit px-10", {
            "opacity-50": !canProceed,
          })}
        >
          Neste
          <ArrowRight width={25} height={25} />
        </Button>
      </div>
    </section>
  );
};
